import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/Tabs'
import BookingHistory from './BookingHistory'
import TrackBookings from './TrackBookings'
import BookAmbulanceForm from './BookAmbulanceForm'
import AmbulanceTypes from './AmbulanceTypes'

const AmbulanceBookingTabs = ({ 
  selectedAmbulanceType, 
  setSelectedAmbulanceType, 
  contacts,
  isLoading,
  setIsLoading,
  error,
  setError
}) => {
  return (
    <div className="w-full">
      <Tabs defaultValue="book" className="w-full">
        <div className="w-full overflow-x-auto">
          <TabsList className="w-full justify-start gap-1 sm:gap-2 min-w-full">
            <TabsTrigger value="book" className="text-xs sm:text-sm whitespace-nowrap flex-shrink-0">
              Book Ambulance
            </TabsTrigger>
            <TabsTrigger value="track" className="text-xs sm:text-sm whitespace-nowrap flex-shrink-0">
              Track Booking
            </TabsTrigger>
            <TabsTrigger value="history" className="text-xs sm:text-sm whitespace-nowrap flex-shrink-0">
              Booking History
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="book" className="mt-6">
          {/* Main Title and Description - Only show on Book Ambulance tab */}
          {/* <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-1">Book Ambulance</h2>
            <p className="text-sm text-gray-600">
              Book ambulances instantly or schedule for later. All bookings include real-time tracking.
            </p>
          </div> */}

          {/* Booking Form Section */}
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <BookAmbulanceForm 
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              error={error}
              setError={setError}
            />
          </div>
        </TabsContent>

        <TabsContent value="track" className="mt-6">
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <TrackBookings />
          </div>
        </TabsContent>

        <TabsContent value="history" className="mt-6">
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <BookingHistory />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default AmbulanceBookingTabs
